import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LiveHelpOutlinedIcon from '@mui/icons-material/LiveHelpOutlined';
import { Button, FormControl, Grid, TextField, Tooltip } from '@mui/material';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { sectionNames } from 'src/components/QueryMenus/checklistQueriesData';

export const SQReportRow = (props: {
  indexVal: string;
  titleName: string;
  title?: string;
  value?: any;
  name: any;
  handle?: any;
  change: any;
  viewNotes: any;
  raisedQueries: string[];
  raisedSectionQueries: string[];
  disabled: boolean;
}) => {
  const { checkPermission } = usePermissionWrapper();
  const perDisable = checkPermission('view_queries_sq_report');

  return (
    <Grid container rowGap={1}>
      <Grid md={12} className="tooltip-section">
        {props.titleName}
        {props.title && (
          <Tooltip title={props.title} placement="right">
            <Button className="grey-btn">
              <InfoOutlinedIcon />
            </Button>
          </Tooltip>
        )}
        <Button
          className={`grey-btn${
            props.raisedQueries.includes(props.name) ||
            (props.raisedSectionQueries.includes(sectionNames.site_qualification_report) && props.indexVal === '0')
              ? ' danger-link'
              : ''
          }`}
          onClick={() => props.viewNotes(props.name)}
          disabled={!perDisable}
        >
          <LiveHelpOutlinedIcon />
        </Button>
      </Grid>
      <Grid md={12} className="description-section">
        <FormControl fullWidth margin="normal">
          <TextField
            id="standard-disabled"
            label="Description"
            variant="outlined"
            defaultValue={props.value}
            name={props.name}
            onBlur={props.handle}
            onChange={props.change}
            disabled={props.disabled}
            inputProps={{ maxLength: 2000 }}
            multiline
            minRows={1}
            maxRows={10}
          />
        </FormControl>
      </Grid>
    </Grid>
  );
};
